import type { CSSProperties, ReactNode } from 'react';

/**
 * Zero-height overlay for canvas affordances so revealing them never changes the measured block
 * height. Hidden affordances stay in the tab order (opacity only) so keyboard users reach them.
 */
export function PriceBookReveal({ revealed, side, children }: { revealed: boolean; side: 'left' | 'right'; children: ReactNode }) {
  const overlay: CSSProperties = {
    position: 'absolute',
    top: 0,
    [side]: 0,
    display: 'inline-flex',
    gap: 2,
    opacity: revealed ? 1 : 0,
    zIndex: 1
  };
  return (
    <span data-canvas-affordance="group" style={{ position: 'relative', display: 'block', height: 0 }}>
      <span data-canvas-affordance="reveal" style={overlay}>
        {children}
      </span>
    </span>
  );
}
